import { render } from "./commonText.vue?vue&type=template&id=76185bac&ts=true"
import script from "./commonText.vue?vue&type=script&setup=true&lang=ts"
export * from "./commonText.vue?vue&type=script&setup=true&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/shared/commonControls/commonText.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "76185bac"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('76185bac', __exports__)) {
    api.reload('76185bac', __exports__)
  }
  
  module.hot.accept("./commonText.vue?vue&type=template&id=76185bac&ts=true", () => {
    api.rerender('76185bac', render)
  })

}


export default __exports__